import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RSQL_AND } from 'utils/filterUtil.ts';
import ExperienceRecordsTableReadOnly from '../../experience/ExperienceRecordsTableReadOnly.tsx';

interface Props {
    contactId?: string;
}

const ExperienceRecordsView: React.FC<Props> = ({ contactId }) => {
    if (!contactId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <h3 className="text-h3 text-fg-secondary">
                <FormattedMessage id="experience-records.experience-records" />
            </h3>
            <ExperienceRecordsTableReadOnly
                createXrNavigationUrl={`/contact/${contactId}/experience-records/new`}
                passiveFilter={`matterClientParty.id==${contactId}${RSQL_AND}hasExperienceRecord==true`}
                canRememberFilters={false}
            />
        </div>
    );
};

export default ExperienceRecordsView;
